import React, { useState, useEffect, useRef } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";
import Loader from "../../../../Components/Loader/Loader";

import { agregarRol, getRoles } from "../../../../API/IT/Roles/RolesRequests";

const RolCrudModal = ({
  rol,
  rolesDialog,
  setRolesDialog,
  getRol,
  modo,
}) => {
  // const toastDialog = useRef(null);
  const toast = useRef(null);
  const [rolesList, setRolesList] = useState("");
  const [loading, setLoading] = useState(true);

  const [show, setShow] = useState(false);

  const initialValues = {
    IdRol: -1,
    Rol: "",
    Description: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

    const getValoresIniciales = async () => {
      setLoading(true)
      const c = await getRoles();
      setRolesList(c);

      setValues({
        ...rol,
      });
      setLoading(false)
    };

  const onHide = () => {
    setRolesDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Rol) {
      error.Rol = true;
      error.error = true;
    }
    if (!/^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\s.\-_]*$/.test(values.Description)) {
      error.Description = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarRoles = async () => {
    const e = verificarInfo();

    if (!e.error) {

      const existingRol = rolesList.find((cur) => cur.Rol === values?.Rol);
      if (
        existingRol &&
        (modo === "Crear" || existingRol.IdRol !== values.IdRol)
      ) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe un Rol con ese nombre"
        );
      }else{
        
        setLoading(true);
        const a = {
          IdRol: values?.IdRol,
          Rol: values?.Rol,
          Description: values?.Description
        };
        const resultado = await agregarRol(a);
        const dialogRes = modo === "Crear" ? "Rol Agregado Correctamente" : "Rol Modificado Correctamente";
        toastShow(toast, "success", "Datos Agregados", dialogRes);
        getRol();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1500);

      }
    } 
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarRoles();
          } else {
            agregarRoles();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (rolesDialog) {
      getValoresIniciales();
    }
  }, [rolesDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Rol" : "Modificar Rol";

  return (
    <div>
      <ConfirmDialog />
      <Dialog
        visible={rolesDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="RolDialog">
          <Loader loading={loading} querySelector={"#RolDialog"} />
          <Toast ref={toast} />
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Rol"
                  value={values.Rol}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{
                    color: "gray",
                    textShadow: "0px 0px 1px white",
                  }}
                  className={error.Rol ? "p-invalid" : ""}
                />
                <label htmlFor="Rol">Rol</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Description"
                  value={values.Description}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{
                    color: "gray",
                    textShadow: "0px 0px 1px white",
                  }}
                  className={error.Description ? "p-invalid" : ""}
                />
                <label htmlFor="Description">Descripción</label>
                {error.Description && (
                  <small className="p-error">
                    La Descripción solo puede contener letras, números, espacios
                    y los caracteres '.', '_', '-'.
                  </small>
                )}
              </span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RolCrudModal;
